import { StringifiableRecord, stringify, stringifyUrl } from 'query-string';
import { DependencyList, useMemo } from 'react';
import { isCloverProdEnvironment } from 'util/Environment';

export const US_GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details';

const PROD_ANDROID_PKG_NAME = 'com.getperka.android';
const NON_PROD_ANDROID_PKG_NAME = 'com.getperka.android.staging';

export function usePlayStoreUrl(url?: string, getReferrer?:() => StringifiableRecord, deps?: DependencyList) {
  const androidPackageName = isCloverProdEnvironment() ? PROD_ANDROID_PKG_NAME : NON_PROD_ANDROID_PKG_NAME;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const referrer = useMemo(() => stringify(getReferrer?.() ?? {}), deps);

  return useMemo(() => stringifyUrl({
    url: US_GOOGLE_PLAY_STORE_URL,
    query: {
      id: androidPackageName,
      url,
      referrer,
    },
  }), [androidPackageName, referrer, url]);
}
